"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLoggerConfiguration = exports.TRACK_THIS_PAGE_VIEW = exports.GET_STATIC_PROPS_ERROR = void 0;
var _types = require("./types");
const GET_STATIC_PROPS_ERROR = exports.GET_STATIC_PROPS_ERROR = 'GET_STATIC_PROPS_ERROR';
const TRACK_THIS_PAGE_VIEW = exports.TRACK_THIS_PAGE_VIEW = 'TRACK_THIS_PAGE_VIEW';
const isNextBuild = process.env.NEXT_PHASE === 'phase-production-build';
const isDevelopment = process.env.NODE_ENV !== 'production';
const defaultLoggerConfiguration = exports.defaultLoggerConfiguration = {
  // Always log everything, this is by default. If it would be false then it would not log anything even with rules applied!
  enabled: true,
  minimalSeverityLevel: isDevelopment ? _types.SeverityLevels.DEBUG : _types.SeverityLevels.WARN,
  // Having less items in default filters array is better
  filters: isDevelopment ? [
  // Enable console loggging for development mode only
  {
    enabled: true,
    byTransportType: _types.LoggerTransportType.CONSOLE
  }] : [
  // Enable application insights logging in production runtime by default
  {
    enabled: !isNextBuild,
    byTransportType: _types.LoggerTransportType.APPLICATION_INSIGHTS
  }]
};
